// Modules
import React from 'react'
import { Form, Formik, FormikHelpers } from 'formik'
import { Radio } from '@dasa-health/components-react'

// Components
import { StyledForm } from './styles'
import { SignUpFooter } from 'redesign/components/molecules/SignUpFooter'

export interface GenderInitial {
    biologicalSex: string
}
interface Props {
    initialValues: GenderInitial
    handleSubmit: (values: GenderInitial, bag: FormikHelpers<GenderInitial>) => void
}

export const GenderForm: React.FC<Props> = ({ initialValues, handleSubmit }) => (
    <Formik initialValues={initialValues} onSubmit={(values, bag) => handleSubmit(values, bag)}>
        {({ values, handleChange }) => (
            <StyledForm>
                <Form autoComplete="off" data-testid="biological-sex-form">
                    <div className="form__radio-button">
                        <div className="form__radio-female">
                            <Radio
                                data-testid="radio-female-input"
                                defaultChecked={values.biologicalSex === 'FEMININO'}
                                label="Feminino"
                                name="biologicalSex"
                                onChange={handleChange}
                                value="FEMININO"
                            />
                        </div>
                        <div className="divider" />
                        <div className="form__radio-male">
                            <Radio
                                data-testid="radio-male-input"
                                defaultChecked={values.biologicalSex === 'MASCULINO'}
                                label="Masculino"
                                name="biologicalSex"
                                onChange={handleChange}
                                value="MASCULINO"
                            />
                        </div>
                        <div className="divider" />
                        <div className="form__radio-intersex">
                            <Radio
                                data-testid="radio-intersex-input"
                                defaultChecked={values.biologicalSex === 'INTERSEXUAL'}
                                label="Intersexo"
                                name="biologicalSex"
                                onChange={handleChange}
                                value="INTERSEXUAL"
                            />
                        </div>
                    </div>
                    <SignUpFooter />
                </Form>
            </StyledForm>
        )}
    </Formik>
)
